import { map, filter } from 'rxjs/operators';

import { push } from '../../../app/reducers';
import { requestVerificationSuccess } from '../../../features/account/reducer/session';
import { RootEpic } from '../index';

export const requestVerificationEpic: RootEpic = (action$) => {
  return action$.pipe(
    filter(requestVerificationSuccess.match),
    map(() => push('/verify-otp')),
  );
};
